module.exports = __webpack_public_path__ + "assets/img/2-xs.9255303.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/picture/why/2-xs.jpg
// module id = MdJ6
// module chunks = 1